import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthStoreService } from '../store/auth-store.service';
import {
  GetSummaryResponse,
  GetValidateResponse,
  PostVerifySessionResponse
} from './auth-data.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthDataService {
  private http = inject(HttpClient);
  private authStoreService = inject(AuthStoreService);

  initSession() {
    const puId =
      new URLSearchParams(window.location.search).get('puId') || sessionStorage.getItem('puId');
    const accessToken = sessionStorage.getItem('puAccessToken') || '';
    const refreshToken = sessionStorage.getItem('puRefreshToken') || '';

    this.authStoreService.setState({ accessToken, refreshToken });

    if (!puId) {
      return of(null);
    }

    sessionStorage.setItem('puId', puId);
    this.authStoreService.setState({ puId, accessToken, refreshToken });

    return of(true);
  }

  validateToken(token: string): Observable<GetValidateResponse> {
    return this.http
      .get<{
        data: { promptupdate: GetValidateResponse }[];
        isError: number;
        errors: any[];
        message?: string;
      }>(`${environment.apiUrl}/validate`, {
        params: {
          puId: token
        }
      })
      .pipe(map(res => res.data[0].promptupdate));
  }

  getSummary(): Observable<GetSummaryResponse> {
    return this.http
      .get<{
        data: GetSummaryResponse[];
        isError: number;
        errors: any[];
        message?: string;
      }>(`${environment.apiUrl}/summary`)
      .pipe(map(res => res.data[0]));
  }

  verifySession(): Observable<PostVerifySessionResponse> {
    return this.http
      .get<{
        data: PostVerifySessionResponse[];
        isError: number;
        errors: any[];
        message?: string;
      }>(`${environment.apiUrl}/verify`)
      .pipe(map(res => res.data[0]));
  }

  refreshToken() {
    return this.http
      .post<{ message: string }>(
        `${environment.apiUrl}/token`,
        {},
        {
          withCredentials: true,
          observe: 'response',
          headers: {
            Authorization: `Bearer ${this.authStoreService.refreshToken() || ''}`
          }
        }
      )
      .pipe(
        tap(res => {
          if (!res.body) {
            return;
          }

          const accessToken = res.headers.get('accessToken') || '';
          const refreshToken = res.headers.get('refreshToken') || '';

          sessionStorage.setItem('puAccessToken', accessToken || '');
          sessionStorage.setItem('puRefreshToken', refreshToken || '');

          this.authStoreService.setState({
            accessToken,
            refreshToken
          });
        })
      );
  }
}
